/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {NgxWebstorageConfiguration as ɵm} from './lib/config';
export {WebStorage as ɵk} from './lib/core/interfaces/webStorage';
export {LocalStorageProvider as ɵb,SessionStorageProvider as ɵd,getLocalStorage as ɵa,getSessionStorage as ɵc} from './lib/core/nativeStorage';
export {Services as ɵn} from './lib/services/index';
export {LocalStorageServiceProvider as ɵg,buildService as ɵf} from './lib/services/localStorage';
export {SessionStorageServiceProvider as ɵi,buildService as ɵh} from './lib/services/sessionStorage';
export {STORAGE_STRATEGIES as ɵl} from './lib/strategies';
export {BaseSyncStorageStrategy as ɵj} from './lib/strategies/baseSyncStorage';
export {Strategies as ɵe} from './lib/strategies/index';